import React, { FC, useCallback, useState, useEffect, useContext, useMemo } from 'react'
import { observer } from 'mobx-react'
import { Price, ProductImage, Stepper, Tags } from 'components'
import { classNames } from '@dt/fe-utils'
import CashierController from 'controllers/cashierController'
import { cartMobx, productSaleMobx } from 'restaurant'
import Config from 'common/config/config'
import MonthSaleInfo from '../MonthSaleInfo'
import productStyleController from '@ctrls/productStyleController'
import { advertMobx } from '@mobxStore'
import './index.scss'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list' | 'advert';
interface IProps {
  type?: TProductItem;
  product: IViewProduct;
  style?: any;
  count?: number;
  lazy?: boolean;
  wrapWidth?: number;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
  size?: 'mini' | 'small' | 'default';
  onClick?: (product: IViewProduct) => void;
  sourceName?: string;
}
// 瀑布流图片的宽度
const ProductItem: FC<IProps> = ({ type = 'waterfall', sourceName = '', size = 'default', product, wrapWidth, style, count, lazy = false, decorate, imgLoaded = false }) => {
  // 是否展示加购按钮 拼单、装修开启、广告餐品下需要展示
  const isShowAddBtn = !!Config.buyTogetherId || !!decorate?.showAddButton || type === 'recommend'

  let { no, name, price, actualPrice, memberPrice, saleCnt, offPrice, isMemberDiscount, isCanTogo, categoryNo = '' } = product || {}
  const ecolor = Config.colorImages[product.categories[0]?.charCodeAt(0) % 4]
  const soldout = saleCnt === 0
  /** 获得图片的宽高 */
  const [productStyle] = useState(() => {
    if (type === 'waterfall' || type === 'advert') {
      const imgWidth = (wrapWidth || window.innerWidth) / 2 - productStyleController.getWidthPer(3)
      const imgHeight = imgWidth * Number(product.picHeight || 360) / Number(product.picWidth || 360)
      return {
        width: imgWidth,
        height: imgHeight
      }
    } else if (type === 'recommend') {
      const imgWidth = window.innerWidth - 32
      const imgHeight = imgWidth * Number(product.picHeight || 360) / Number(product.picWidth || 360)
      return {
        width: imgWidth,
        height: imgHeight
      }
    }
  })

  // 库存数量
  const inventoryCnt = useMemo(() => {
    return productSaleMobx.productNoToScaleCntMap?.[product.no]?.cnt
  }, [productSaleMobx.saleList])

  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    advertMobx.pickProductFromAdvert(product.no, 'product')
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product
    })
  }, [count])

  const handleClickItem = () => {
    advertMobx.pickProductFromAdvert(product.no, 'product')
    CashierController.showProductDetail(product)
  }

  const [defaultImg, setDefault] = useState<string>('')

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic
    setDefault(defaultImgUrl)
  }, [product])

  return (
    <div
      className={classNames(
        'product-item waterfall',
        type,
        {
          'sold-out': soldout,
        },
        size
      )}
      style={style ? {
        visibility: style.left ? 'visible' : 'hidden',
        left: style.left,
        top: style.top
      } : null}
      id={sourceName + 'product' + no + categoryNo}
      onClick={handleClickItem}
    >
      {
        !defaultImg
          ? (
            <div
              className='watercolor' style={{
                backgroundColor: ecolor
              }}
            >
            </div>
          ) : (
            <ProductImage
              color={!defaultImg ? product.no : ''}
              imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
              width={productStyle.width}
              height={productStyle.height}
              className={type === 'waterfall' ? 'waterfall-img' : ''}
            />
          )
      }
      <div className='product-info'>
        <div className='product-name' style={{ fontSize: `${decorate?.fontSetting?.name?.fontSize || 16}px`, fontWeight: decorate?.fontSetting?.name?.fontWeight ? 700 : 500 }}>{name}</div>
        {
          !!product.intro && <p className='product-intro' dangerouslySetInnerHTML={{ __html: product.intro.replace(/<style[\S\s]*<\/style>/g, '').replace(/<img[^>]*>/g, '') }}></p>
        }
        <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} salesCnt={product.salesCnt} disableTogo={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} disableSingleSale={!product.isSingleSale} />
        <MonthSaleInfo showHot={decorate?.showHot} showMonthSales={decorate?.showMonthSales} showSalesCnt={decorate?.showSalesCnt} inventoryCnt={inventoryCnt} statSaleCnt={product.statSaleCnt} statAvatar={product.statAvatar} />
        <div className='product-actions'>
          <Price
            decorate={decorate}
            className='product-price'
            price={price}
            actualPrice={actualPrice}
            hideMarketPrice={!!count}
            soldOut={soldout}
            offPrice={offPrice}
            memberPrice={memberPrice}
            isMemberDiscount={isMemberDiscount}
          />
          {!soldout && isShowAddBtn && <Stepper cnt={count} onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !isCanTogo} />}
          {
            soldout && <span className='sold-out-msg'>{i18n.t('common.soldout')}</span>
          }
        </div>
      </div>
      {
        !!count && !isShowAddBtn && <div className='product-cnt'>{count}</div>
      }
    </div>
  )
}
export default observer(ProductItem)
